import React from "react"
import RegisterMember from "../components/auth/RegisterMembers"
const RegisterNewMember = () => {
  return <RegisterMember />
}

export default RegisterNewMember
